import { ThemeColorInterface } from './';

export const GreenTheme: ThemeColorInterface[] = [
    { key: '--rgb-main-background-color', value: '3, 30, 34' },
    { key: '--rgb-body-background-color', value: '13, 47, 50' },
    { key: '--rgb-header-background-color', value: '18, 44, 46' },
    { key: '--rgb-subheader-background-color', value: '26, 58, 61' },
    { key: '--rgb-dropdown-background-color', value: '32, 86, 89' },
    { key: '--rgb-icons', value: '117, 164, 164' },
    { key: '--rgb-primary-cta-color', value: '24, 211, 144' },
    { key: '--rgb-contrast-cta-color', value: '255, 255, 255' },
    { key: '--rgb-secondary-contrast-cta-color', value: '117, 164, 164' },
    { key: '--rgb-cta-layer-color', value: '255, 255, 255' },
    { key: '--rgb-system-green', value: '84, 180, 137' },
    { key: '--rgb-system-red', value: '232, 94, 89' },
    { key: '--rgb-system-yellow', value: '232, 175, 89' },
    { key: '--rgb-asks', value: '232, 94, 89' },
    { key: '--rgb-bids', value: '84, 180, 137' },
    { key: '--rgb-primary-text-color', value: '241, 250, 247' },
    { key: '--rgb-text-contrast-color', value: '18, 56, 58' },
    { key: '--rgb-input-background-color', value: '41, 23, 86' },
    { key: '--rgb-divider-color', value: '196, 196, 199' },
    { key: '--rgb-shadow-color', value: '3, 30, 34' },
    { key: '--rgb-landing-background-color', value: '251, 251, 251' },
    { key: '--rgb-strength-meter-very-strong', value: '108, 239, 239' },
];
